import { render, staticRenderFns } from "./TemplateSelectDialog.vue?vue&type=template&id=212b1266&scoped=true&"
import script from "./TemplateSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelectDialog.vue?vue&type=style&index=0&id=212b1266&lang=scss&scoped=true&"
import style1 from "./TemplateSelectDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b1266",
  null
  
)

export default component.exports